import type { CompanionEvent } from '../types/companion'

type Listener = (event: CompanionEvent) => void

/** Simple pub/sub for decoupled communication within the companion */
export class EventBus {
  private listeners = new Set<Listener>()

  on(listener: Listener): () => void {
    this.listeners.add(listener)
    return () => this.listeners.delete(listener)
  }

  emit(event: CompanionEvent): void {
    for (const listener of this.listeners) {
      listener(event)
    }
  }

  clear(): void {
    this.listeners.clear()
  }
}
